export default __webpack_public_path__ + "static/media/MarsCentra-Bold.96d3309a.woff2";